import { type ModalId } from '@heidi/schema/ml-scribe';

/**
 * PROVISIONAL cast: in the backend `ModalId` enum but not the generated copy; drop after
 * a schema regen. The id STRING is frozen: it keys `seenModalIds` and `ModalView` records.
 */
export const PENDING_TEAM_INVITE_MODAL_ID = 'T0_PENDING_TEAM_INVITE' as ModalId;
